import {publishAnalyticsEventForMinorConversion} from "@khan/analytics-learning-time";

type Args = {
    tabClicked: "TOOLS" | "MY_DOCUMENTS";
};

export function publishAiGuideDocumentsToolsTabClickedEvent({
    tabClicked,
}: Args) {
    publishAnalyticsEventForMinorConversion({
        eventType: "AiTeacherToolsDocumentsToolsTabClicked",
        eventSchemaVersion: 1,
        tabClicked,
    });
}
